import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel'
import '../assets/owl carousel/owl.carousel.min.css'
import '../assets/owl carousel/owl.theme.default.min.css'
import { Slider } from '@material-ui/core'
// Components
import LinksMap from '../components/LinksMap';
import PageTransition from '../components/PageTransition';
import ProductFilters, {FiltersNav} from '../components/ProductFilters';
import ProductCard from '../components/ProductCard';
// CSS
import '../assets/css/products.css'
// Images
import Banner from '../assets/images/banner.jpg'

export default function Products(props) {
  const [productCard, setProductCard] = useState(1);
  const [productsFilterShow, setProductsFilterShow] = useState(false);

  
  useEffect(() => {
    if(productsFilterShow){
      document.body.style.overflow = 'hidden';
    }
    else{
      document.body.style.overflow = 'auto';
    }
  }, [productsFilterShow])

  return (
    <div className='products_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path:'/', active: false}, {name: 'Category', path:'/category', active: true}]} pageName="Category" />

      <div className='container wrapper'>
        <div className={productsFilterShow? 'side_content show' : 'side_content'}>
          <div className='close_btn'>
            <span className='fas fa-times' onClick={() => {setProductsFilterShow(false)}}></span>
          </div>
          <ProductFilters page='products_page' currency={props.currency} setProductsFilterShow={setProductsFilterShow} setProductCard={setProductCard} />
          <div className='featured_products'>
            <div className='section_title'>Featured</div>
            <OwlCarousel
              className='owl-theme'
              items={1}
              autoPlay={true}
              autoplayHoverPause={true}
              autoplaySpeed={1000}
              dots={true}
            >
              <div className='item'>
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
              </div>
              <div className='item'>
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
              </div>
              <div className='item'>
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
                <ProductCard 
                  card={2}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  ratings={4}
                  realPrice='100'
                  discountPrice='80'
                />
              </div>
            </OwlCarousel>
          </div>
        </div>
  
        <div className='main_content'>
          <div className='slider'>
            <OwlCarousel
              className='owl-theme'
              items={1}
              autoPlay={true}
              autoplayHoverPause={true}
              autoplaySpeed={1000}
              dots={false}
            >
              <div className='item'>
                <img src={require('../assets/images/products page banners/1.png')} alt='product' width={100} />
              </div>
              <div className='item'>
                <img src={require('../assets/images/products page banners/2.png')} alt='product' width={100} />
              </div>
            </OwlCarousel>
          </div>

          <FiltersNav page='products_page' setProductsFilterShow={setProductsFilterShow} setProductCard={setProductCard} />

          <div className={productCard === 1? 'products flex' : productCard === 2? 'products' : 'products flex'}>
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={productCard}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
          </div>

          <div className='pagination'>
            <Link to='/blogs/page/4' className='fas fa-chevron-left'></Link>
            <Link to='/blogs/page/1'>1</Link>
            <Link to='/blogs/page/2'>2</Link>
            <Link to='/blogs/page/4' className='fas fa-chevron-right'></Link>
          </div>
        </div>
      </div>
    </div>
  )
}
